import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from '@heroicons/react/solid';

const faqs = [
  {
    question: 'What is crowdfunding?',
    answer:
      'Crowdfunding is the practice of funding a project or venture by raising small amounts of money from a large number of people, typically via the internet.',
  },
  {
    question: 'How does crowdfunding work?',
    answer:
      'Crowdfunding platforms allow project creators to pitch their ideas to potential backers, who can contribute money in exchange for rewards or equity in the project.',
  },
  {
    question: 'What types of projects can be crowdfunded?',
    answer:
      'Almost any type of project can be crowdfunded, including creative projects, business ventures, and social causes.',
  },
];

function Faq() {
  const [openIndex, setOpenIndex] = useState(-1);

  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="max-w-screen-lg mx-auto mt-20 mb-20">
      <h2 className="text-3xl font-bold text-center mb-10">Frequently Asked Questions</h2>
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index}>
            <button
              className="flex justify-between w-full py-4 px-4 bg-white hover:bg-gray-100 rounded-lg shadow-md transition-all duration-200"
              onClick={() => handleToggle(index)}
            >
              <span className="font-bold">{faq.question}</span>
              <span>{openIndex === index ? <MinusIcon className="h-6 w-6" /> : <PlusIcon className="h-6 w-6" />}</span>
            </button>
            {openIndex === index && <p className="mt-4 text-gray-600">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faq;